import BaseIsPlatform from "./BaseIsPlatform.vue";

export default BaseIsPlatform;
